export default __webpack_public_path__ + "static/media/about us page_value.26449310.png";